import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseCardRequestReasonsProps<T> = {
  filters?: {
    search?: string;
    page?: number;
  };
  mapper?: (data: any) => T,
};

export const useCardRequestReasons = <T,>({
  filters: { search, page } = {},
  mapper = Mapper.default<T>(),
}: UseCardRequestReasonsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['cardRequestReasons', search, page],
    queryFn: () => {
      return privateAxios.get(`/card_request_reasons`, {
        params: {
          search,
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
